import { isSlideQuestionSlide } from '@llx/common';
import { Slide } from '@llx/common';
import { isSlideItemSelectableAnswerItem } from '@llx/common';
import { SelectableAnswerSlideItemType } from '@llx/common';

import { AnswerFieldsFragment } from '@/@generated/codegen/API';
import { NoAnswerItem } from '@/utils/errors/NoAnswerItem';
import { NoUserAnswer } from '@/utils/errors/NoUserAnswer';

export default function getAnswerItemsAccordingToUserAnswer(
  userID: string,
  slideID: string,
  allAnswers: AnswerFieldsFragment[],
  slides: Slide[]
) {
  const userAnswer = allAnswers.find((el) => el.userId === userID);

  if (!userAnswer) throw new NoUserAnswer();

  const questionSlide = slides.find((slide) => slide.id === slideID);
  if (!questionSlide || !isSlideQuestionSlide(questionSlide)) {
    throw new Error('TopRightItem - questionSlide is undefined or it is not a question slide');
  }
  const selectableItems: SelectableAnswerSlideItemType[] = questionSlide.items.filter(
    isSlideItemSelectableAnswerItem
  );
  const answerItems = selectableItems.filter((item) => userAnswer.answerIndexes!.includes(item.id));
  if (userAnswer.answerIndexes!.length !== answerItems.length) throw new NoAnswerItem();
  return answerItems;
}
